// /src/pages/LoginLanding.jsx
/* eslint-disable */
import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";



import mascot from "../assets/images/splash.png";

import { useAppConfig } from "../context/AppConfigContext"; // 🔹 추가

export default function LoginLanding() {
  const nav = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [openSignup, setOpenSignup] = useState(false);

  const { config, loading } = useAppConfig();      // ✅ 전역 설정 + 로딩 상태
  const loginCfg = config.login;                  // 설정은 항상 있다고 가정

  if (loading || !loginCfg) {
    // 설정 불러오는 동안은 화면 안 보여주거나, 필요하면 로딩 스피너를 그려도 됨
    return null;
  }

  // const bgImg = loginCfg.background?.img;         // ✅ 폴백 없이 그대로 사용

  const bgImg = mascot; 

  const buttons = loginCfg.buttons || [];         // 버튼 배열 (항상 2개 온다고 가정)
  const [btn1, btn2] = buttons;
  const guestCfg = loginCfg.guestButton || {};    // 게스트 버튼 설정
  const buttonsOffset = loginCfg.buttonsOffset ?? 40; // 🔹 슬라이더 값 (px)
  const guestTop = guestCfg.topOffset ?? 12;


  console.log("buttonsOffset", buttonsOffset);

  const goGuest = () => {
    try {
      localStorage.setItem("dhm.session", JSON.stringify({ auth: "guest", at: Date.now() }));
    } catch { }
    nav("/home");
  };

  const handleLoginDone = (accountId) => {
    nav("/home", { replace: true, state: { accountId } });
  };
  const handleSignupDone = (phoneE164) => {
    nav("/register", { replace: true, state: { phoneE164 } });
  };

  return (
    <Wrap>
  

      <TopBar $top={guestTop}>
        <GuestPill
          type="button"
          onClick={goGuest}
          aria-label="게스트로 둘러보기"
          $bg={guestCfg.bgColor}
          $color={guestCfg.textColor}
          $border={guestCfg.borderColor}
        >
          {guestCfg.label}
        </GuestPill>
      </TopBar>

      <Main>
        <Hero>
          <Mascot src={bgImg} alt="Hey'Way 캐릭터" />
        </Hero>


        <Buttons $offset={buttonsOffset}>
          <ButtonPrimary
            type="button"
            onClick={() => nav("/login")}
            $bg={btn1?.bgColor}
            $color={btn1?.textColor}
          >
            {btn1?.label}
          </ButtonPrimary>
          <ButtonGhost
            type="button"
            onClick={() => nav("/auth/phone")}
            $bg={btn2?.bgColor}
            $color={btn2?.textColor}
            $border={btn2?.bgColor}
          >
            {btn2?.label}
          </ButtonGhost>
        </Buttons>
      </Main>
    </Wrap>
  );
}


/* ========== styled-components ========== */
const Wrap = styled.div`
  min-height: 100dvh;
  background: #fff;
  color: #222;
  display: flex;
  flex-direction: column;
  position: relative;   /* 🔹 추가: TopBar absolute 기준 */
`;
const TopBar = styled.header`
  position: absolute;
  top: ${({ $top }) => ($top != null ? `${$top}px` : "12px")};  /* 🔹 위 여백 조절 */
  right: 16px;
  left: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px;
  z-index: 10; /* 버튼이 내용 위에 올라오게 */
`;
const GuestPill = styled.button`
  border: 2px solid ${({ $border }) => $border};
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  .arrow {
    font-weight: 900;
  }
`;

const Buttons = styled.div`
  width: min(560px, 92vw);
  display: flex;
  gap: 14px;
  z-index: 999;
  margin-top: 8px;
  margin-bottom: ${({ $offset }) =>
    $offset != null
      ? `max(16px, env(safe-area-inset-bottom) + ${$offset}px)`
      : "max(16px, env(safe-area-inset-bottom) + 40px)"};
`;

const ButtonBase = styled.button`
  flex: 1;
  height: 56px;
  border-radius: 16px;
  font-weight: 800;
  font-size: 17px;
`;

const ButtonPrimary = styled(ButtonBase)`
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border: none;

  &:active {
    filter: brightness(0.95);
  }
`;

const ButtonGhost = styled(ButtonBase)`
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border: 2px solid ${({ $border }) => $border};

  &:active {
    filter: brightness(0.98);
  }
`;






const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px;
  padding-bottom: 12px;
  justify-content: space-between;   /* 🔹 상단 Hero와 하단 버튼을 화면 안에서 위·아래로 배치 */
`;

/* 중앙 크게 */
const Hero = styled.div`
  display:grid; place-items:center; gap:12px;
  transform: scale(1);
  transform-origin: center top;
  margin-top:50px;

  @media (min-width: 390px) { transform: scale(1); }
  @media (min-width: 480px) { transform: scale(1); }
  @media (min-height: 820px) { transform: scale(1); }
`;

const Brand = styled.h1`
  margin:12px 0 0;
  font-size: clamp(32px, 7.4vw, 52px);
  font-weight: 800;
  letter-spacing: -0.01em;
`;

const Mascot = styled.img`
  width: clamp(340px, 78vw, 900px);
  max-height: 72vh;
  object-fit: contain; height:auto;
  margin: 16px 0 6px;
  user-select:none; -webkit-user-drag:none;

  @media (min-height: 860px) {
    max-height: 76vh;
    margin-top: 20px;
  }
`;

/* ⬇️ 버튼을 더 아래로 밀어내는 스페이서 */
const Spacer = styled.div`
 flex: 1.6;           /* 여유 더 줘서 버튼 아래로 */
  min-height: 16dvh;   /* 화면 높이 기준 여유도 조금 확대 */
`;


